import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../../../app/shared/shared.services';
import { HeaderService } from '../../../shared/service/header.service';
import { ProjectService } from '../../../shared/service/project.service';
import { UserService } from '../../../shared/service/user.service';

@Component({
  selector: 'app-subheader',
  templateUrl: './subheader.component.html'
})
export class SubheaderComponent implements OnInit {
  project: any = [];
  constructor(
    public headerService: HeaderService,
    public sharedService: SharedService,
    private projectSvc: ProjectService,
    public userSvc: UserService) {



    this.headerService.header = null;
    this.projectSvc.SwitchProjectParams();
    this.projectSvc.Current$.subscribe(() => this.project = this.projectSvc.Projects);


  }

  ngOnInit() {
    this.userSvc.Init();
  }

  toggleSideNav() {
    if (window.innerWidth < 768) {
      this.sharedService.sideNav.toggle();
    }
  }



}
